import { render } from "./oap-video-immersive.vue?vue&type=template&id=080f66e4"
import script from "./oap-video-immersive.vue?vue&type=script&lang=js"
export * from "./oap-video-immersive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__